import { type GLTF } from 'three/addons/loaders/GLTFLoader.js'
import { appGltfLoader } from './appGltfLoader'

export default function GLTFSignalPromiseFactory(modelFileAsStringOrUrl: string): Promise<GLTF> {
  // console.log('GLTFSignalPromiseFactory')
  return new Promise((resolve, reject) => {
    // console.log('GLTFSignalPromiseFactory')
    appGltfLoader.load(modelFileAsStringOrUrl, function (ModelObj) {
      // console.log('GLTFSignalPromiseFactory.loader.load')
      // console.log('setModelObj', ModelObj)
      resolve(ModelObj)
      // console.log(ModelObj.scene)
    }, undefined, function (error) {
      console.error(error)
      reject(error)
    })
  })
}
